const config: any = {
  rowSelection: false,
  fieldControl: false,
  toolbar: false,
  columns: [
    {
      title: '文件名',
      dataIndex: 'fileName',
      width: 200,
      render: 'nameRender'
    },
    {
      title: <div style={{textAlign: 'center'}}>上传数量</div>,
      dataIndex: 'dataCount',
      name: 'dataCount',
      width: 100,
      render: (v) => <div style={{textAlign: 'center'}}>{v}</div>
    },
    {
      title: '失败原因',
      dataIndex: 'reason',
      width: 200,
      name: 'reason',
      render: 'renderReason',
      ellipsis: {
        showTitle: true,
        overlayInnerStyle: {
          width: 360,
          maxHeight: 200,
          overflowY: 'scroll'
        },
      },
    },
    {
      title: '上传时间',
      dataIndex: 'createdTime',
      itemType: 'dateTime',
      width: 160,
    },
  ],
  search: false,
  // footer: [
  //   {
  //     label: '下载导入模板',
  //     type: 'primary',
  //     events: ['onClick:downloadImportTemp'],
  //   },
  // ],
}

export default config
